import {CheckCircleOutlined} from "@ant-design/icons";
import {Col} from "antd";

const Content = ({content}) =>{

    return (
        <Col span={24} className={"flex"} style={{ paddingBottom: 12 }}>
            <CheckCircleOutlined style={{fontSize: 24, color: "#7F56D9"}}/>
            <span style={{paddingLeft: 12}}
                  className={"text-base font-normal"}>
                {content}
            </span>
        </Col>
    )
}

export default Content
